import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import GenericTab from "~/components/GenericTab";
import { ActionsTab } from "./ActionsTab";
import { AtonsFaultSearcTab } from "./AtonsFaultSearchTab";
import { SecurityDeviceSearchTab } from "./SecurityDeviceSearchTab";
import { WaterTrafficSignTab } from "./WaterTrafficSignTab";

export const fairwayTabOptions = ["security-device-search", ""] as const;
export type FairwayTabType = typeof fairwayTabOptions[number];

export const FairwayTabs = (): JSX.Element => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  return (
    <GenericTab
      tab={pathname}
      tabs={[
        {
          component: <SecurityDeviceSearchTab />,
          id: "/fairway-maintenance-reporting",
          label: t("fairwayReport:securityDeviceSearch"),
          href: "/fairway-maintenance-reporting",
        },
        {
          component: <ActionsTab />,
          id: "/fairway-maintenance-reporting/actions",
          label: t("fairwayReport:actions"),
          href: "/fairway-maintenance-reporting/actions",
        },
        {
          component: <WaterTrafficSignTab isDisabled />,
          id: "/fairway-maintenance-reporting/water-traffic-sign",
          label: t("fairwayReport:waterTrafficSign"),
          href: "/fairway-maintenance-reporting/water-traffic-sign",
        },
        {
          component: <AtonsFaultSearcTab />,
          id: "/fairway-maintenance-reporting/fault-search",
          label: t("fairwayReport:faultSearch"),
          href: "/fairway-maintenance-reporting/fault-search",
        },
      ]}
    />
  );
};
